import React from "react";
import { TakeXPayYPromo } from "./TakeXPayYPromotion.styles";

export function TakeXPayYPromotion({
  product,
  styles,
  canvasScale,
  className,
}) {
  return (
    <TakeXPayYPromo
      styles={styles}
      canvasScale={canvasScale}
      className={`take-x-pay-y-span ${className || ""} flex`}
    >
      <p className="txt take-x">
        Leve <span className="number">{product.takeX}</span>
      </p>
      <p className="txt pay-y">
        {product.payY ? "pague" : "por"}{" "}
        {product.payY && <span className="number">{product.payY}</span>}
      </p>
    </TakeXPayYPromo>
  );
}
